export const SearchControlsVisibility = {
    FULL: 'full',
    CONDENSED: 'condensed',
};
